import {
  ArrowDownIcon,
  ArrowUpIcon,
  TrashIcon,
} from '@heroicons/react/24/outline';
import { SectionLoading } from '../shared/SectionLoading';

interface FaultItemDisplayProps {
  index: number;
  title: string;
  description: string;
}

export function FaultItemDisplay({
  index,
  title,
  description,
}: FaultItemDisplayProps) {
  return (
    <div className="flex divide-x divide-gray-200 dark:divide-gray-700 px-4 py-3">
      <div className="pr-3 flex items-start">
        <span className="text-lg font-bold">{`#${index}`}</span>
      </div>
      <div className="pl-3">
        <span className="font-semibold">{title}</span>
        <div className="mt-1 text-sm text-gray-500 dark:text-gray-400">
          {description}
        </div>
      </div>
    </div>
  );
}

interface FaultItemErrorProps {
  itemType: 'Cause' | 'Action';
  id: string;
}

export function FaultItemError({ itemType, id }: FaultItemErrorProps) {
  return (
    <div className="border border-gray-200 dark:border-gray-700 rounded-lg p-4">
      <p className="text-sm text-red-600 dark:text-red-400">
        {itemType} not found: {id}
      </p>
    </div>
  );
}

interface FaultItemEditProps extends FaultItemDisplayProps {
  onMoveUp: () => void;
  onMoveDown: () => void;
  onRemove: () => void;
}

export function FaultItemEdit({
  title,
  description,
  onMoveUp,
  onMoveDown,
  onRemove,
}: FaultItemEditProps) {
  return (
    <div className="flex flex-row justify-between px-4 py-3">
      <div>
        <span className="font-semibold">{title}</span>
        <div className="mt-1 text-sm text-gray-500 dark:text-gray-400">
          {description}
        </div>
      </div>
      <div className="flex flex-row items-center space-x-4 border-l border-gray-200 dark:border-gray-700 pl-4">
        <div className="h-full flex flex-col justify-between">
          <ArrowUpIcon
            className="h-5 w-5 text-gray-400 dark:text-gray-500 hover:text-gray-500 dark:hover:text-gray-400 hover:cursor-pointer"
            onClick={onMoveUp}
          />
          <ArrowDownIcon
            className="h-5 w-5 text-gray-400 dark:text-gray-500 hover:text-gray-500 dark:hover:text-gray-400 hover:cursor-pointer"
            onClick={onMoveDown}
          />
        </div>
        <TrashIcon
          className="h-5 w-5 text-red-400 dark:text-red-500 hover:text-red-500 dark:hover:text-red-400 hover:cursor-pointer"
          onClick={onRemove}
        />
      </div>
    </div>
  );
}

export function FaultItemLoading() {
  return <SectionLoading size="xs" />;
}
